import { } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { JiraObjectDataset } from 'app/model/dataset/jira.dataset';
import { TabularCopySource } from './tabular-type.copysource';

@Metamodel.model({
    name: 'JiraSource',
    display: [],
    tags: { datasetModel: Metamodel.modelFor(JiraObjectDataset) }
})
export class JiraCopySource extends TabularCopySource {
}
